import React, { useEffect, useRef, useState } from 'react';
// import _ from 'lodash';

import { CircularProgress } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { red } from '@material-ui/core/colors';
const wAndH = { width: '100%', height: '100%' };

export const Scanner = ({ savePhoto, setSavePhoto, setJpegForUpload }) => {
	const videoRef = useRef(null);
	const [cameraIsLoading, setCameraIsLoading] = useState(true);
	const [cameraOn, setCameraOn] = useState(false);
	const [cameraError, setCameraError] = useState();

	useEffect(() => {
		setCameraOn(true);
	}, []);

	useEffect(() => {
		if (!cameraOn) {
			return;
		}

		const video = videoRef.current;

		if (!navigator.mediaDevices) {
			const err = 'Problems starting camera. No devices.';
			console.error(err);
			setCameraError('Error: ' + err);
			setCameraIsLoading(false);
			return;
		}

		navigator.mediaDevices
			.getUserMedia({
				video: {
					width: 3840,
					height: 2160,
					//width: 560,
					//height: 720,
					facingMode: 'environment',
				},
			})
			.then((stream) => {
				if (!video) {
					console.log('Video went away');
					return;
				}

				video.srcObject = stream;
				video.play();
				video.onloadedmetadata = () => {
					setCameraIsLoading(false);
				};
			})
			.catch((err) => {
				console.error('Problems starting camera', err);
				setCameraError('Err:' + err);
				setCameraIsLoading(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cameraOn]);

	useEffect(() => {
		let videoElement;

		if (videoRef.current) {
			videoElement = videoRef.current;
		}

		return () => {
			if (videoElement && videoElement.srcObject) {
				videoElement.srcObject.getTracks().forEach((track) => {
					if (track.readyState === 'live') {
						track.stop();
					}
				});
			}
		};
	}, [videoRef]);

	useEffect(() => {
		if (!savePhoto) {
			return;
		}

		/*
		function saveJpeg(jpegUrl) {
			// eslint-disable-next-line no-undef
			// const scanner = new jscanify();
			const newImg = document.createElement('img');
			newImg.src = jpegUrl;

			newImg.style.width = '100%';
			containerRef.current.innerHTML = '';
			containerRef.current.append(newImg);
			setJpegForUpload(jpegUrl);
		}
		*/

		// eslint-disable-next-line no-undef
		// const scanner = new jscanify();
		const video = videoRef.current;

		//		const canvas = canvasRef.current;
		const canvas = document.createElement('canvas');
		if (!canvas) {
			console.log('could not create canvas');
			return;
		}
		canvas.width = video.videoWidth;
		canvas.height = video.videoHeight;
		const canvasCtx = canvas.getContext('2d');
		canvasCtx.drawImage(video, 0, 0, canvas.width, canvas.height);
		const jpegUrl = canvas.toDataURL('image/jpeg');

		//saveJpeg(jpegUrl);
		setJpegForUpload(jpegUrl);
		setSavePhoto(false);
	}, [savePhoto, setSavePhoto, setJpegForUpload]);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				height: '100%',
				background: '#111',
			}}
		>
			<div
				style={{
					display: 'flex',
					width: '100%',
					height: '100%',
					justifyContent: 'center',
				}}
			>
				<div
					style={{
						width: '100%',
						height: '100%',
						textAlign: 'center',
						position: 'relative',
						minHeight: '80vw',
						backgroundColor: '#111',
						marginRight: '1vw',
						marginLeft: '1vw',
						//border: '1px solid #555',
					}}
				>
					{cameraIsLoading && (
						<div
							style={{
								position: 'absolute',
								top: '40%',
								left: 0,
								right: 0,
								bottom: 0,
								padding: '4vw',
								fontStyle: 'italic',
								fontSize: '130%',
								color: '#999',
								zIndex: 5,
								height: '100%',
							}}
						>
							<CircularProgress />
							<div style={{ color: 'white' }}>Camera is loading</div>
						</div>
					)}
					{!!cameraError && (
						<div
							style={{
								position: 'absolute',
								top: '30%',
								left: 0,
								right: 0,
								bottom: 0,
								padding: '4vw',
								fontStyle: 'italic',
								fontSize: '130%',
								color: '#999',
								zIndex: 5,
							}}
						>
							<div>
								<ErrorIcon style={{ color: red[500], width: '5vw', height: '5vw' }} />
							</div>
							<div>Camera failed to start</div>
							<div style={{ fontSize: '75%' }}>{cameraError}</div>
						</div>
					)}
					<video
						autoPlay={true}
						playsInline={true}
						muted={true}
						ref={videoRef}
						id="video"
						style={{
							...wAndH,
						}}
					></video>
				</div>
			</div>
		</div>
	);
};
